// extracted by mini-css-extract-plugin
export default {"messageModalContainer":"MessageModal_messageModalContainer__Dzob4"};